import { getAppTitle, getTextThemeProvider } from 'venn-ui-kit';

export const PrintDisabledText = {
  header: `In order to print ${getAppTitle()} output, access to Report Lab is required`,
  subHeader: `Please contact ${getTextThemeProvider().salesEmail} to learn more`,
};
